<template>
  <p class="notification-bar-item">- <slot /></p>
</template>

<style>
.notification-bar-item {
  line-height: 1.1rem;
  margin: 0.5rem 0 0 0;
}
</style>

<script>
export default {
  name: 'NotificationBarItem'
}
</script>
